"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {on} from "@elements/dom-utils";

export function init() {
    console.log('iniiit');
    onFind('.js-ajax-form', function ($element) {
        on('fetch.ajax-form', function () {
            console.log('looooog');
            let offset = $element.getBoundingClientRect().top + window.pageYOffset - 120;

            if (window.pageYOffset > offset) {
                try {
                    window.scroll({
                        top: offset,
                        behavior: 'smooth'
                    });
                } catch (e) {
                    window.scrollTo(0, offset)
                }
            }
        }, $element);
    });
}